module.exports = __webpack_public_path__ + "static/media/tax-documents.32f39655.svg";